/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  '4panel': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g fill-rule="nonzero" _fill="none"><circle pid="0" cx="12" cy="12" r="12" _fill="#8300BF"/><path pid="1" d="M19.5 6.5v11h-15v-11h15zm-8 6h-6v4h6v-4zm7 0h-6v4h6v-4zm-7-5h-6v4h6v-4zm7 0h-6v4h6v-4z" _fill="#FFF"/></g>'
  }
})
